module.exports = __webpack_public_path__ + "assets/img/erw-linkedin.94bd762c.png";